import React, { useState } from 'react';
import { Table, DateTimeUtils, ViewMore } from 'dyl-components';
import { Icon } from 'semantic-ui-react';
import SessionSubTable from './SessionSubTable';

const UserStats = ({ session }) => {
    return (
        <Table.CollapsibleRowContent>
            <Table.Cell colSpan={1} />
            <Table.Cell colSpan={3}>
                <SessionSubTable users={[
                    {
                        ...session,
                        name: session.user?.username,
                    }
                ]} />
            </Table.Cell>
            <Table.Cell colSpan={2} />
        </Table.CollapsibleRowContent>
    )
}

const SessionRow = ({ session }) => {
    const [isExpanded, setExpanded] = useState(false);
    const onToggleRow = () => {
        setExpanded(!isExpanded);
    };

    const isSessionInProgress = session.active;
    return (
        <Table.CollapsibleRow
            collapsed={!isExpanded}
            onToggle={onToggleRow}
            subrowContent={<UserStats session_id={session.id} session={session} />}
        >
            <Table.Cell width={3}>
                <div><b>{DateTimeUtils.formatEpoch(session.start, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                <div>{DateTimeUtils.formatEpoch(session.start, DateTimeUtils.TIME_FORMAT)}</div>
            </Table.Cell>
            <Table.Cell width={2}>{session.sent ?? ''}</Table.Cell>
            <Table.Cell width={2}>{isSessionInProgress ? "In Progress" : "Complete"}</Table.Cell>
            <Table.Cell>
                <div style={{ display: "flex" }}>
                    <div style={{ maxWidth: "256px" }}>
                        {session?.message && <ViewMore text={session.message} />}
                    </div>
                    <div>
                        {session.attachment?.length > 0 && (
                            <Icon name='paperclip' className='CampaignSessionSummary__attachmentIcon' />
                        )}
                    </div>
                </div>
            </Table.Cell>
        </Table.CollapsibleRow>
    );
};

export default SessionRow;
